import React from "react";
import useWinterWheelsPanel from "../../../../hooks/customize/winterwheels/useWinterWheelsPanel";
import { useBnbSelector } from "../../../../redux/store";
import { calculateWinterWheelPrice } from "../../../../utils/typedUtils";
import { BnbLabel } from "../../../../utils/labels";
import * as Styles from "./styles/WinterWheels";
import Price from "../../common/price/Price";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { showPrice } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { getCarDBAssetSrcSet } from "../../../../../../shared-logic/utils/imageUtils";

const WinterWheelsPanel = (): JSX.Element => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const { activeWinterWheel, cheapestWinterWheel, previewImageUrl, openModal, clearSelectedWheel } =
        useWinterWheelsPanel();

    return (
        <Styles.Wrapper>
            <Flex.Row alignItems="center">
                <Flex.Col width={{ _: 1, sm: 7 / 12 }}>
                    <Styles.WheelPreview>
                        <Styles.ImageWrapper>
                            <img
                                {...getCarDBAssetSrcSet(settings, [{ width: 120, height: 120 }], previewImageUrl)}
                                loading="lazy"
                                width="60"
                                height="60"
                                sizes="60px"
                                alt={activeWinterWheel?.name}
                            />
                        </Styles.ImageWrapper>
                        <Styles.WheelHeader>
                            <Styles.Name>
                                <Type.Strong mb={0}>
                                    {activeWinterWheel ? (
                                        activeWinterWheel.name
                                    ) : (
                                        <BnbLabel label="winterWheelsHeader" />
                                    )}
                                </Type.Strong>
                            </Styles.Name>
                            {activeWinterWheel ? (
                                <Type.Strong>
                                    <Price
                                        price={calculateWinterWheelPrice(activeWinterWheel)}
                                        financeItemId={activeWinterWheel.id}
                                    />
                                </Type.Strong>
                            ) : (
                                showPrice(settings) &&
                                (cheapestWinterWheel.price.cash > 0 || cheapestWinterWheel.price.monthly > 0) && (
                                    <Type.Strong>
                                        <Price
                                            price={calculateWinterWheelPrice(cheapestWinterWheel)}
                                            financeItemId={cheapestWinterWheel.id}
                                        />
                                    </Type.Strong>
                                )
                            )}
                            <Styles.OptionalText>
                                <Type.SmallText>
                                    <BnbLabel label="winterWheelsOptional" />
                                </Type.SmallText>
                            </Styles.OptionalText>
                        </Styles.WheelHeader>
                    </Styles.WheelPreview>
                </Flex.Col>
                <Flex.Col width={{ _: 1, sm: 5 / 12 }}>
                    <Styles.Actions>
                        <Button.Secondary onClick={openModal} mx={0} dark>
                            <Text.Button>
                                <BnbLabel
                                    label={activeWinterWheel ? "winterWheelsEditButton" : "winterWheelsChooseButton"}
                                />
                            </Text.Button>
                        </Button.Secondary>
                        {activeWinterWheel && (
                            <>
                                <Button.Secondary onClick={clearSelectedWheel} ml={2} dark>
                                    <Text.Button>
                                        <BnbLabel label="winterWheelsRemoveButton" />
                                    </Text.Button>
                                </Button.Secondary>
                            </>
                        )}
                    </Styles.Actions>
                </Flex.Col>
            </Flex.Row>
        </Styles.Wrapper>
    );
};

export default WinterWheelsPanel;
